/**
*** 基础数据--项目模板
 */
<template>
	<div id="projectTemp" class="jc-page">
		<div class="jc-panel jc-page-head">
			<div class="header-title">{{ headerTitle }}</div>
			<div class="header-operation">
				<el-form ref="form" :model="form">
						<el-form-item>
								<el-input v-model="form.projectName" placeholder="项目名称"></el-input>
						</el-form-item>   
						<!-- <el-form-item> -->
								<el-button class="button" @click="handleQuery">查询</el-button>
						<!-- </el-form-item>
						<el-form-item> -->
								<el-button class="button" @click="handleDeletMulti">删除</el-button>
						<!-- </el-form-item>
						<el-form-item> -->
								<el-button class="button" @click="handleAdd">添加</el-button>
						<!-- </el-form-item> -->
				</el-form>
			</div>
		</div>
		<div class="jc-table-container jc-scroll-panel">
			<el-table
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%"
				@selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55"></el-table-column>
						<!-- <el-table-column type="index" label="序号" width="55"></el-table-column> -->
						<el-table-column label="项目名称" width="200">
							<template slot-scope="scope">{{scope.row.checkup_project_name}}</template>
						</el-table-column>
						<el-table-column label="机构类型" >
							<template slot-scope="scope">{{scope.row.organization_type_name}}</template>
						</el-table-column>
						<!-- <el-table-column label="包含检查表">
							<template slot-scope="scope">{{scope.row.table}}</template>
						</el-table-column> -->
						<el-table-column label="操作" width="100">
							<template slot-scope="scope">
								<el-button @click="handleEdit(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
								<span>|</span>
								<el-button type="text" size="small" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
							</template>
						</el-table-column>
				</el-table>
				<el-pagination
				background
				style="text-align:right"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="currentPage"
				:page-size="count"
				layout="total, prev, pager, next"
				:total="total"
				>
				</el-pagination>
		</div>

		<el-dialog title="添加项目模板" :visible.sync="dialogVisible" class="dialog">
			<el-form ref="projectForm" :model="projectForm">
				<el-row>
					<el-col :span="12">
						<el-form-item label="项目名称">
							<el-input v-model="projectForm.projectName" placeholder="请输入项目名称"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="机构类型">
							<!-- <el-input v-model="projectForm.projectName" placeholder="请输入机构类型"></el-input> -->
							<el-select v-model="projectForm.type" placeholder="请选择机构类型" @change="handleOrganTypeChange(projectForm.type)">
                                <el-option 
                                v-for="item in organOptions"
                                :key="item.organization_type_id"
                                :label="item.organization_type_name"
                                :value="item.organization_type_id"></el-option>
                            </el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<p><span>检查表添加</span><i class="el-icon-caret-top"></i></p>	
				<el-form-item label="检查表名称">
					<!-- <el-input v-model="personForm.tableName" placeholder="请选择检查表"></el-input> -->
					<el-cascader
						v-model="projectForm.tableName"
    					:options="options"
    					:props="{ multiple: true, checkStrictly: true,value:'checkup_subject_id',label:'checkup_subject_name'}"
    					 placeholder="请选择检查表">
					</el-cascader>
					<!-- <el-select v-model="personForm.tableName" placeholder="请选择">
						<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value"
							multiple
							>
						</el-option>
					</el-select> -->

				</el-form-item>	
			</el-form>
			<div slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" @click="submit()">确定</el-button>
			</div>
		</el-dialog>

		<!-- 详情dialog对话框 -->
		<el-dialog title="项目模板详情" :visible.sync="detailDialogVisible" class="dialog">
			<el-form ref="detailForm" :model="detailForm">
				<el-row>
					<el-col :span="12">
						<el-form-item label="项目名称">
							<el-input v-model="detailForm.projectName" placeholder="请输入项目名称"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="机构类型">
							<!-- <el-input v-model="projectForm.projectName" placeholder="请输入机构类型"></el-input> -->
							<el-select v-model="detailForm.type" placeholder="请选择机构类型" @change="handleOrganTypeChange(detailForm.type)">
                                <el-option 
                                v-for="item in organOptions"
                                :key="item.organization_type_id"
                                :label="item.organization_type_name"
                                :value="item.organization_type_id"></el-option>
                            </el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<p><span>检查表添加</span><i class="el-icon-caret-top"></i></p>	
				<el-form-item label="检查表名称">
					<!-- <el-input v-model="personForm.tableName" placeholder="请选择检查表"></el-input> -->
					<el-cascader
						v-model="detailForm.tableName"
    					:options="options"
    					:props="{ multiple: true, checkStrictly: true,value:'checkup_subject_id',label:'checkup_subject_name'}"
    					 placeholder="请选择检查表">
					</el-cascader>
					<!-- <el-select v-model="personForm.tableName" placeholder="请选择">
						<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value"
							multiple
							>
						</el-option>
					</el-select> -->

				</el-form-item>	
			</el-form>
			<div slot="footer" class="dialog-footer">
					<el-button @click="detailDialogVisible = false">取消</el-button>
					<el-button type="primary" @click="detailSubmit()">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import {deleteCheckupProjectInfo, getCheckupProjectDetail, saveCheckupProjectInfo, getCheckupProjectList, getOrganizationTypeList, getCheckupSubjectList} from '@/apis/projectTemp'
export default {
  name:"ProjectTemp",
	data(){
		return {
			headerTitle:"项目模板",
			form:{
				projectName:""
			}, // 头部-右边表单
			dialogVisible:false, // 对话框显示标识
			detailDialogVisible:false, // 详情对话框显示标识
			tableData:[
				// {
				// 	checkup_project_name:"三年行动",
				// 	organization_type_name:"",
				// 	table:"校园安全检查表/消防安全检查表"
				// }
			], // 表格内容
			multipleSelection:[], // 表格选择
			projectForm:{
				projectName:"",
				type:"",
				tableName:""
			}, // 添加项目模板对话框中-表单内容
			detailForm:{
				projectId:"",
				projectName:"",
				type:"",
				tableName:""
			}, // 详情对话框中-表单内容
			organOptions:[
            ], // 机构类型
			options:[
				// {
				// 	value:'1',
				// 	label:'校园安全检查表'
				// },
			], // 添加项目模板对话框中-检查表名称选择
			currentPage:1,// 当前页数
            count:10,//表格页数
            total:0,// 总条目数
		}
	},
	mounted(){
		//查询
		this.handleQuery();
	},
	methods:{
		handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.handleQuery();
        },
		// 表格多选
		handleSelectionChange(val){
			this.multipleSelection = [];
			//organization_id
			val.forEach(item => {
			this.multipleSelection.push(parseInt(item.checkup_project_id));
			})
			console.log('批量选择',this.multipleSelection);
		},
		// 批量删除-点击头部“删除”按钮（38-检查专题-删除检查专项信息）
		handleDeletMulti(){
			this.$confirm('是否确定删除数据？', "提示").then(()=>{
				deleteCheckupProjectInfo({checkup_project_id_list:this.multipleSelection}).then(res => {
				console.log('批量删除',res);
				if(res.data.status == "1"){
					this.$message({
					message: '删除成功！',
					type: 'success'
				});
				this.handleQuery()
				}else {
					this.$message.error(`${res.data.msg}`);
				}
			})
			})
			
		},
		// 表格中点击"删除"（38-检查专题-删除检查专项信息）
		handleDelete(index,row){
			this.$confirm('是否确定删除数据？', "提示").then(()=>{
				deleteCheckupProjectInfo({checkup_project_id_list:[row.checkup_project_id]}).then(res => {
				console.log('单个删除',res);
				if(res.data.status == "1"){
					this.$message({
					message: '删除成功！',
					type: 'success'
				});
				this.handleQuery()
				}else {
					this.$message.error(`${res.data.msg}`);
				}
			})
			})
			
		},
		// 点击表格中"编辑"--36-检查专题-获得检查专项详情
		handleEdit(index,row){
			console.log('编辑',index,row);
			this.detailDialogVisible = true;
			this.getOrganTypeList();
			this.handleOrganTypeChange()
			let obj = {
				checkup_project_id:parseInt(row.checkup_project_id)
			}
			getCheckupProjectDetail(obj).then(res => {
				console.log('项目详情',res);
				if(res.data.status ==="1"){
					let arr = [];
					let data = res.data.data.checkup_project_info;
					data.checkup_subject_list.forEach(item =>{
						arr.push(item.checkup_subject_id);
					})
					this.detailForm.projectId = data.checkup_project_id;
					this.detailForm.projectName = data.checkup_project_name;
					this.detailForm.type = data.organization_type_info.organization_type_id;
					this.detailForm.tableName = arr;
					//this.options = data.checkup_subject_list;
				}
				
			})
		},
		// 点击头部“添加”按钮
		handleAdd(){
			this.dialogVisible = true;
			this.getOrganTypeList();
			this.handleOrganTypeChange()
		},
		// 点击添加dialog对话框中“确定”按钮(37-检查专题-保存检查专项信息)
		submit(){
			let arr = [];
			this.projectForm.tableName.forEach(item => {
				arr.push(parseInt(item[0]));
			})
			let obj = {
				checkup_project_id:0,
				checkup_project_name:this.projectForm.projectName,
				organization_type_id:this.projectForm.type,
				checkup_subject_id_list:arr
			};
			saveCheckupProjectInfo(obj).then(res => {
				console.log('保存',res);
				if(res.data.status == "1"){
					this.dialogVisible = false;
					this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
					this.handleQuery();
					this.projectForm = {
						projectName:"",
						type:"",
						tableName:""
					}
				}else{
					this.$message.error(`${res.data.msg}`);
				}
			})
		},
		// 点击项目详情dialog对话框中“确定”按钮(37-检查专题-保存检查专项信息)
		detailSubmit(){
			let that = this
			let arr = [];
			this.detailForm.tableName.forEach(item => {
				arr.push(parseInt(item[0]));
			})
			
			let obj = {
				checkup_project_id:this.detailForm.projectId,
				checkup_project_name:this.detailForm.projectName,
				organization_type_id:this.detailForm.type,
				checkup_subject_id_list:arr
			};
			saveCheckupProjectInfo(obj).then(res => {
				console.log('保存',res);
				if(res.data.status == "1"){
					that.detailDialogVisible = false;
					that.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
					this.handleQuery();
				}else{
					this.$message.error(`${res.data.msg}`);
				}
			})
		},
		// 点击头部"查询"按钮（35-检查专项-获得检查专项列表）
		handleQuery(){
			let obj = {
				checkup_project_name:this.form.projectName,
				organization_type_id:0,
				pagination:{
					page:this.currentPage,
					count:this.count
				}
			};
			getCheckupProjectList(obj).then(res => {
				console.log('获取项目列表',res);
				if(res.status == 200 && res.data.status=="1"){
					this.tableData = res.data.data.checkup_project_list;
					this.total = parseInt(res.data.data.paginated.total);
					this.count = parseInt(res.data.data.paginated.count);
					this.$message({
                        message: '获取成功！',
                        type: 'success'
                    }); 
				}else {
					this.$message.error(`${res.data.msg}`);
				}
			})
		},
		 // 7-基础-获取机构类型
        getOrganTypeList(){
            // 构造参数
            getOrganizationTypeList().then(res =>{
                console.log('获取机构类型',res.data.data);
                this.organOptions=res.data.data.organization_type_list;
                console.log('organOptions',this.organOptions);
            })
        },
		// 机构类型改变-选择检查表名称（28-检查专题-获得检查专题列表）
		handleOrganTypeChange(organization_type_id){
			let obj = {
				checkup_subject_name:"",
				organization_type_id:organization_type_id ? organization_type_id : "",
				investigation_level_id:"",
				pagination:{
					page:"1",
					count:"1000"
				}
			}
			getCheckupSubjectList(obj).then(res => {
				console.log('检查表列表',res);
				this.options = res.data.data.checkup_subject_list
			})
		},
		
	}
}
</script>
<style scoped>
#projectTemp{
    position: relative;
}
.header {
    width: 100%;
    height: 35px !important;
    border-bottom: 1px solid #ccc;
}
.header-left {
    width: 200px;
    text-align: left;
    position: absolute;
}
.header-title {
    font-weight: bold;
}
.header-right {
    position: absolute;
    right: 20px;
    /* width: 30%; */
    height: 35px;
    top: -15px;
}
.el-form{
    display: flex;
    height: 35px;
}
.el-form-item {
    width: 180px;
    margin-right: 10px;
}
.button {
    height: 38px;
    color: #fff;
    background-color: #000;
}
#projectTemp >>> .el-input__inner {
    height: 35px;
    padding: 0 10px;
    border: 1px solid #000;
}
#projectTemp >>> .el-input input::-webkit-input-placeholder{
    color: #9e9fa3;
}
/* 表格样式修改 */
.el-table{
    color: #000;
}
#projectTemp >>> .el-table thead{
    color:#000;
    font-weight: unset;
}
#projectTemp >>> .el-table__header{
    width: 100%;
   
}
#projectTemp >>> .el-table th.el-table__cell{
    background-color: #f3f3f3;
}
/* #organlist >>> .el-table tr{
    
} */
#projectTemp >>> .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: unset;
}
.el-button--text{
    color: #000;
    font-size: 13px;
}
.el-table__row>td{
    border: none;
}
.el-table::before{
    height: 0px;
}
#projectTemp >>> .el-checkbox__inner{
    width: 16px;
    height: 16px;
    border: 1px solid #9e9fa3;
}
/* 对话框样式修改 */
#projectTemp >>> .dialog .el-dialog{
	width: 40%;
}
#projectTemp >>> .dialog .el-dialog__header{
    text-align: left;
}
#projectTemp >>> .dialog .el-dialog__title{
    font-size: 20px; 
}
#projectTemp >>> .dialog .el-dialog__body{
    padding: 10px 20px;
    color: #000;
}
#projectTemp >>> .dialog .el-dialog__body .el-form{
    width: 100%;
    height: 100%;
    display: block;
}
#projectTemp >>> .dialog .el-dialog__body .el-form-item {
    width: 85%;
    margin-bottom: 15px;
}
#projectTemp >>> .dialog .el-form-item__label{
    color: #000;
    font-size: 16px;
    text-align: left;
    line-height: 35px;
}
#projectTemp >>> .dialog .el-input__inner {
    border: 1px solid #409eff;
    color: #000;
}
#projectTemp >>> .dialog .el-select {
    width: 100%;
}
#projectTemp >>> .dialog .el-dialog__footer {
    padding: 0px 20px 20px;
}
.dialog p {
	/* text-align: left; */
	font-size: 16px;
	font-weight: bold;
	display: flex;
	justify-content: space-between;
	width: 85%;
}
.dialog .el-cascader {
	width: 100%;
}
#projectTemp >>> .dialog .el-input__suffix {
	color: #000;
}

#projectTemp >>> .dialog .el-tag.el-tag--info{
	color: #000;
}
</style>


// WEBPACK FOOTER //
// src/views/backStage/children/ProjectTemp/ProjectTemp.vue